import React from 'react';

import styled from 'styled-components';

import EnrolledGroupCard from './EnrolledGroupCard';
import { IGroupItems } from '../../types/customGroupingTypes';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { PlAN_TYPES } from '@constants/individualPortal/customGrouping/customGrouping.constants';

const StyledEnrolledContainer = styled.div`
    padding: 4px 0px;
`;

interface IEnrolledMembersWrapperProps {
    enrolledGroups: IGroupItems[];
    planType: PlAN_TYPES;
}

export default function EnrolledMembersWrapper(props: IEnrolledMembersWrapperProps) {
    const { enrolledGroups, planType } = props;
    return (
        <div className="card-container">
            {enrolledGroups.map(group => (
                <ConditionalRendering isTrue={!!group.groupEnrollmentId} key={group.groupEnrollmentId}>
                    <StyledEnrolledContainer>
                        <EnrolledGroupCard key={group.groupEnrollmentId} group={group} planType={planType} />
                    </StyledEnrolledContainer>
                </ConditionalRendering>
            ))}
        </div>
    );
}
